import React from 'react';
import Button from '@material-ui/core/Button';

import './ActionButton.scss';

const ActionButton = React.forwardRef(({
    text,
    icon,
    className,
    component,
    type,
    handleClick,
    disabled,
    buttonStyle,
    ...props
}, ref) => {
    const getClassName = () => {
        const classNames = ['action-button'];

        if (className) {
            classNames.push(className);
        }

        if (buttonStyle) {
            classNames.push(buttonStyle);
        }

        return classNames.join(' ');
    };

    return (
        <Button
            className={getClassName()}
            type={type}
            onClick={handleClick}
            component={component ? component : 'button'}
            disabled={disabled}
            ref={ref}
            {...props}
        >
            {icon && React.cloneElement(icon, { className: 'icon' })}
            {text}
        </Button>
    );
});

export default ActionButton;
